/**
 * This page is shown when a user attempts to purchase an addon that's already included with their
 * current plan. Mirrors NotEligible but omits the "Upgrade My Plan" CTA — there's nothing for the
 * customer to do. Thin wrapper over the shared CheckoutMessage layout; message/description come from
 * navigation state, with English fallbacks for direct navigation.
 */

import React from 'react'
import CheckoutMessage from '../../../components/checkoutMessage'

function AddonIncluded() {
    return (
        <CheckoutMessage
            fallbackMessage="This add-on is already included with your plan"
            fallbackDescription="Your current plan already provides access to this feature, so there's nothing more to add."
        />
    )
}

export default AddonIncluded
